var map = {
	"./8.jpg": 51364,
	"./FLR.jpg": 76004,
	"./fish 3.jpg": 4747,
	"./flowers 01.jpg": 55207,
	"./flowers 1.jpg": 53133,
	"./flowers 2.jpg": 7202,
	"./flr 1.jpg": 585,
	"./girl 2.jpg": 71894,
	"./girl 3.jpg": 43507,
	"./girl 4.jpg": 3200,
	"./girl with dora.jpg": 7864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62124;